module.exports = __webpack_public_path__ + "img/avatar-s-24.e9860ff6.jpg";